import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { authorization } from '../../../containers/authentication/constants'
import { useAuthStore } from '../../../zustand/authentication/use-auth-store'
import { authMutationKeys } from '../constants'

export const useLogin2faMutation = () => {
  const { loginSuccessful } = useAuthStore()

  const handleLogin2fa = async (email, password, twoFaCode) => {
    const config = {
      method: 'post',
      headers: {
        Authorization: authorization
      },
      data: {
        username: email,
        password,
        code: twoFaCode,
        grant_type: 'password'
      }
    }

    const { data } = await api('/api/oauth/token', config)

    return data
  }

  const handleMutation = async ({ email, password, twoFaCode }) => {
    const data = await handleLogin2fa(email, password, twoFaCode)
    if (data) {
      loginSuccessful(data)
    }
  }

  return useMutation({
    mutationFn: async (credentials) => await handleMutation(credentials),
    mutationKey: authMutationKeys.TWO_FA,
    retry: false
  })
}
